import React, {useState} from 'react';
import ModalLayout from "@layouts/modal";
import ButtonBase from "@atoms/button.base";
import ButtonTransparent from "@atoms/button.transparent";
import CircleLoading from "@molecules/lotties/circle_loading";
import {removeUserProperty} from "@models/property";
import {isEmpty} from "@helpers/helpers";

const PropertyDeleteModal = ({show, setShow, property_id, handleShowNoResult, setShowManageModal}) => {
    const [loading, setLoading] = useState(false);

    const handleRemove = (e) => {
        setLoading(true);

        const propertyContainerCount = document.querySelectorAll('.property-container').length;
        const propertyContainer = document.querySelector('.property-container-' + property_id);

        removeUserProperty(property_id).then(result => {
            if (!isEmpty(setShowManageModal)) {
                setShowManageModal(false);
            }
            setShow(false);

            propertyContainer.style.transition = 'opacity 500ms ease';
            propertyContainer.style.opacity = '0';

            setTimeout(function () {
                propertyContainer.parentNode.removeChild(propertyContainer);

                if (propertyContainerCount <= 1) {
                    handleShowNoResult();
                }
            }, 700);

            setLoading(false)
        })
    };

    return (
        <ModalLayout show={show} setShow={setShow} modalDialogClass="modal-sm report-modal" dialogBodyClassName="px-0">
            <div className="text-center mt-8 mt-lg-0">
                <h3 className="h2">حذف آگهی</h3>

                <div className="px-24 px-lg-32 pt-24 pb-40 pb-md-0">
                    <p>از حذف این آگهی مطمئنید؟</p>

                    <div className="mt-32 d-flex">
                        <ButtonTransparent onClick={() => setShow(false)} className="col-6">بی‌خیال</ButtonTransparent>
                        <ButtonBase disabled={loading} onClick={(e) => handleRemove(e)} color="danger-text col-6">
                            {
                                (loading) ?
                                    <CircleLoading width={24} height={24}/>
                                    :
                                    'حذف کن'
                            }
                        </ButtonBase>
                    </div>
                </div>
            </div>
        </ModalLayout>
    );
};

export default React.memo(PropertyDeleteModal);
